module.exports = __webpack_public_path__ + "media/Video 68.741c4056.mp4";